import {Component, TextComponent} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Localization} from '../utils/Localization.js';

export class UILocalize extends Component {
    static TypeName = 'UI-localize';

    @property.string('')
    key = '';

    start() {
        const tc = this.object.getComponent(TextComponent);
        if (tc) {
            tc.text = Localization.instance.get(this.key);
        }
    }
}
